import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { utils } from '@app/shared';
import { ToastService } from '@teorema/patron';
import {
  FilterField,
  FilterOperator,
  FindOptions,
  OrderBy,
  SystemModel,
  Task,
  Ticket,
  TicketDetail,
  TicketLog,
  TicketStatus,
  TicketType,
  User,
} from 'src/app/models';
import {
  TcCurrentLogService,
  TcDataService,
  TcTaskService,
  TcTicketLogService,
  TcTicketService,
} from 'src/app/shared/services';
import { constants } from '../../../../shared/utils/constants';
import { SystemPercentagesComponent } from './system-percentages/system-percentages.component';

@Component({
  selector: 'app-ticket-logs-modal',
  templateUrl: './ticket-logs-modal.component.html',
  standalone: false,
})
export class TicketLogsModalComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() entity!: Ticket;
  @Input() user!: User;
  @Input() taskId;
  @Input() inputTask?: Task; //Informado quando abre o modal de apontamentos à partir de uma tarefa do tasks.component
  @Input() inputSystem?: SystemModel;
  @Input() apontarDesapontarDireto: boolean = false;

  @Output() assembleTicket = new EventEmitter();
  @Output() saved = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter();

  @ViewChild(SystemPercentagesComponent) systemPercentagesComponent!: SystemPercentagesComponent;

  logForm!: FormGroup;
  ticketLogAttendanceTypes = constants.ticketcenter.ticketLogAttendanceTypes;
  ticketLogTypes = constants.ticketcenter.ticketLogTypes;
  ticketLogDepartmentTypes = constants.ticketcenter.ticketLogDepartmentTypes;

  currentTicketLog?: TicketLog;
  formTicketLog?: TicketLog;
  loading = false;
  searchingCurrentTicketLog = false;
  saving = false;
  ticketLogs: TicketLog[] = [];
  totalItems = 0;
  oldTicketStatus?: TicketStatus;
  pub = false;
  shouldAddDescriptionToTicketDetails = true;
  findOptions: FindOptions = {
    orderBy: 'start_date',
  };
  //OBS: Se adicionar mais atributos aqui ou alterar o valor padrão ajustar também o método reset

  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    private tcTicketLogService: TcTicketLogService,
    private tcDataServiice: TcDataService,
    private tcTicketService: TcTicketService,
    private currentTicketLogService: TcCurrentLogService,
    private tcTaskService: TcTaskService
  ) {
    this.logForm = this.formBuilder.group({
      startDate: [null /*, Validators.required*/], //Não funciona essa bosta de validação
      endDate: [null],
      attendanceType: [null],
      type: [null],
      departmentType: [null],
      status: [null],
      task: [null],
      description: [null],
      isPublic: [null],
      shouldAddDescriptionToTicketDetails: [null],
    });
    this.reset();
  }

  ngOnInit(): void {
    this.loadShouldAddDescriptionToTicketDetails();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue && !changes['visible']?.previousValue) {
      this.modalOpened();
    }
  }

  modalOpened() {
    if (this.entity?.status && this.entity.status.description !== 'Desenvolvimento') {
      this.toastService.show({
        color: 'warn',
        message: 'O status do chamado não está em desenvolvimento',
      });
    }

    if (!this.apontarDesapontarDireto) {
      this.findOptions.page = 1;
      this.findTicketLogs();
    }

    this.findCurrentTicketLog();
  }

  reset() {
    this.logForm.reset();
    this.currentTicketLog = undefined;
    this.formTicketLog = undefined;
    this.ticketLogs = [];
    this.totalItems = 0;
    this.oldTicketStatus = undefined;
    this.pub = false;
    this.findOptions = {
      page: 1,
      perPage: 5,
      orderBy: [
        {
          field: 'start_date',
          direction: 'desc',
        } as OrderBy,
        {
          field: 'end_date',
          direction: 'desc',
        } as OrderBy,
      ],
      filters: [],
    };

    if (this.systemPercentagesComponent) {
      this.systemPercentagesComponent.reset();
    }
  }

  paginate(findOptions?: FindOptions) {
    if (findOptions) this.findOptions = { ...this.findOptions, ...findOptions };

    this.findTicketLogs();
  }

  async findTicketLogs() {
    if (this.entity) {
      this.loading = true;
      this.ticketLogs = [];
      this.totalItems = 0;

      if (!this.findOptions?.filters?.length) {
        this.findOptions?.filters?.push(
          new FilterField({
            name: 'equal[ticket_id]',
            value: this.entity!.id,
            operator: FilterOperator.has,
            label: '',
          })
        );
      }

      this.addInputFilter(this.inputTask, 'equal[task_id]');
      this.addInputFilter(this.inputSystem, 'equal[system_id]');

      let response = await this.tcTicketLogService.findAll(this.findOptions).catch(e => {
        console.error(e);
        this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
      });
      this.loading = false;

      if (response?.data?.length) {
        this.ticketLogs = response.data;
      }

      if (response?.meta?.total != null && response?.meta?.total >= 0) {
        this.totalItems = response.meta.total;
      }
    }
  }

  private addInputFilter(input, name) {
    let index = this.findOptions.filters!.findIndex(f => f.name === name);

    if (index > -1) {
      this.findOptions.filters?.splice(index, 1);
    }

    if (input) {
      this.findOptions.filters!.push(
        new FilterField({
          name: name,
          value: input?.id,
          operator: FilterOperator.has,
          label: '',
        })
      );
    }
  }

  setFormTicketLog() {
    this.logForm.reset();
    this.logForm.get('isPublic')?.patchValue(this.pub);
    this.logForm
      .get('shouldAddDescriptionToTicketDetails')
      ?.patchValue(this.shouldAddDescriptionToTicketDetails);

    if (this.currentTicketLog) {
      this.formTicketLog = this.currentTicketLog;

      if (!this.formTicketLog.end_date) {
        this.formTicketLog.end_date = new Date();
      }

      this.logForm.get('startDate')?.patchValue(new Date(this.formTicketLog.start_date!));
      this.logForm.get('endDate')?.patchValue(new Date(this.formTicketLog.end_date!));

      if (this.formTicketLog.type) {
        let aux = this.ticketLogTypes.find(o => o.value === this.formTicketLog!.type);

        if (aux) {
          this.logForm.get('type')?.patchValue(aux);
        }
      }

      if (this.formTicketLog.department_type) {
        let aux = this.ticketLogDepartmentTypes.find(
          o => o.value === this.formTicketLog!.department_type
        );

        if (aux) {
          this.logForm.get('departmentType')?.patchValue(aux);
        }
      }

      this.logForm.get('attendanceType')?.patchValue(this.formTicketLog.attendance_type);
      this.logForm.get('status')?.patchValue(this.formTicketLog.status);
      this.logForm.get('description')?.patchValue(this.formTicketLog.description);
      this.logForm.get('task')?.patchValue(this.formTicketLog.task?.id);
    } else {
      this.formTicketLog = new TicketLog();
      this.formTicketLog.situation = false;
      this.formTicketLog.user = this.user;
      this.formTicketLog.ticket = this.entity;

      this.logForm.get('startDate')?.patchValue(new Date());
      this.logForm
        .get('attendanceType')
        ?.patchValue(this.ticketLogAttendanceTypes.find(o => o.value === 'I').value);
      this.logForm.get('type')?.patchValue(this.ticketLogTypes.find(o => o.value === 'M'));
      this.logForm
        .get('departmentType')
        ?.patchValue(this.ticketLogDepartmentTypes.find(o => o.value === 'A'));

      if (this.entity) {
        this.logForm.get('status')?.patchValue(this.entity.status);

        if (
          (this.entity.ticket_type as TicketType)?.description === 'Chamada Defeito / Retrabalho'
        ) {
          this.logForm.get('type')?.patchValue(this.ticketLogTypes.find(o => o.value === 'E'));
        }
      }

      if (this.inputTask) {
        this.logForm.get('task')?.patchValue(this.inputTask!.id);

        if (this.inputTask.user && this.user && this.inputTask.user.id !== this.user.id) {
          //Se o desenvolvedor da tarefa for diferente do usuário logado, seta o tipo do apontamento como acompanhamneto
          this.logForm.get('type')?.patchValue(this.ticketLogTypes.find(o => o.value === 'A'));
        }
      }

      if (this.inputSystem) {
        this.formTicketLog!.system = this.inputSystem;
      }
    }

    this.oldTicketStatus = this.logForm.get('status')?.value;

    let aux = this.logForm.get('task')?.value?.id;
    if (aux) {
      this.taskId = aux;
    }

    this.setStrDates();
  }

  setStrDates() {
    setTimeout(() => {
      let startDateField = this.logForm.get('startDate');
      let endDateField = this.logForm.get('endDate');

      if (startDateField?.value) {
        startDateField.patchValue(utils.dateToDateInputStr(startDateField?.value, true));
      }

      if (endDateField?.value) {
        endDateField.patchValue(utils.dateToDateInputStr(endDateField?.value, true));
      }
    }, 1); //Sem esse timeout por alguma razão do além as vezes ele não preenche o valor no input
  }

  async save() {
    this.formTicketLog!.start_date = this.logForm.get('startDate')?.value;
    this.formTicketLog!.end_date = this.logForm.get('endDate')?.value;
    this.formTicketLog!.attendance_type = this.logForm.get('attendanceType')?.value;
    this.formTicketLog!.type = this.logForm.get('type')?.value?.value;
    this.formTicketLog!.department_type = this.logForm.get('departmentType')?.value?.value;
    this.formTicketLog!.status = this.logForm.get('status')?.value;
    this.formTicketLog!.description = this.logForm.get('description')?.value;
    this.taskId = this.logForm.get('task')?.value;
    this.pub = this.logForm.get('isPublic')?.value;
    this.shouldAddDescriptionToTicketDetails = this.logForm.get(
      'shouldAddDescriptionToTicketDetails'
    )?.value;

    if (!this.formTicketLog!.status) {
      this.toastService.show({
        color: 'error',
        message: 'Status não informado',
      });
      return;
    }

    if (!this.systemPercentagesComponent.validate()) {
      return;
    }

    let newTicketTicketStatus = this.formTicketLog!.status;

    let startDateTime;
    let endDateTime;

    if (this.formTicketLog!.start_date?.toString()?.length) {
      startDateTime = new Date(this.formTicketLog!.start_date).getTime();
    } else {
      this.toastService.show({
        color: 'error',
        message: 'Hora inicial não informada',
      });
      return;
    }

    if (this.formTicketLog!.end_date?.toString()?.length) {
      endDateTime = new Date(this.formTicketLog!.end_date).getTime();
    }

    if (startDateTime && endDateTime && startDateTime > endDateTime) {
      this.toastService.show({
        color: 'error',
        message: 'A hora inicial não pode ser posterior a hora final',
      });
      return;
    }

    if (endDateTime) {
      this.formTicketLog!.situation = true;
      this.formTicketLog!.status = this.oldTicketStatus;
    }

    if (!this.formTicketLog!.id) {
      this.selectSingleTicketLogTask();

      if (this.entity?.tasks?.length && !this.taskId) {
        this.toastService.show({
          color: 'error',
          message: 'Por favor selecione a tarefa à ser apontada',
        });
        return;
      }
    }

    if (this.taskId) {
      this.formTicketLog!.task = new Task();
      this.formTicketLog!.task.id = this.taskId;
    } else {
      this.formTicketLog!.task = undefined;
    }

    this.saving = true;
    let systemsPercentages = this.systemPercentagesComponent.setSystemPercentagesDates(
      startDateTime,
      endDateTime
    );
    let response;

    if (endDateTime && systemsPercentages?.length) {
      for (let i = 0; i < systemsPercentages.length; i++) {
        let sp = systemsPercentages[i];
        let body = this.systemPercentagesComponent.getSaveBody(this.formTicketLog!, sp, i);

        let tempResponse = await this.tcTicketLogService.save(body).catch(e => {
          this.toastService.showResponseError(e, 'Houve um erro ao salvar');
        });

        if (i == 0) {
          response = tempResponse;
        }

        if (tempResponse?.id) {
          this.toastService.show({
            color: 'success',
            message:
              'Apontamento ' +
              (i + 1) +
              '/' +
              systemsPercentages.length +
              ' no sistema ' +
              sp.system?.description +
              ' salvo com sucesso',
          });
        } else {
          break;
        }
      }
    } else {
      let body = JSON.parse(JSON.stringify(this.formTicketLog));
      response = await this.tcTicketLogService.save(body).catch(e => {
        this.toastService.showResponseError(e, 'Houve um erro ao salvar');
      });
    }

    this.saving = false;

    if (response?.id) {
      this.formTicketLog = response;
      this.taskId = this.formTicketLog?.task?.id;

      if (this.entity.status?.id !== newTicketTicketStatus?.id) {
        this.entity.status = newTicketTicketStatus;
        this.updateTicketStatus();
      }

      if (response.task?.id && this.entity.tasks) {
        let task = this.entity.tasks.find(t => t.id === response?.task?.id);

        if (task) {
          task.status = newTicketTicketStatus;
          this.updateTaskStatus(task);
        }
      }

      if (this.formTicketLog!.end_date) {
        this.toastService.show({
          color: 'success',
          message: 'Apontamento finalizado com sucesso',
        });
        this.currentTicketLog = undefined;
      } else {
        this.toastService.show({
          color: 'success',
          message: 'Apontamento iniciado com sucesso',
        });
      }

      localStorage.setItem('ticketLogsModalLastPub', this.pub ? 'true' : 'false');
      localStorage.setItem(
        'shouldAddDescriptionToTicketDetails',
        this.shouldAddDescriptionToTicketDetails ? 'true' : 'false'
      );

      if (
        this.shouldAddDescriptionToTicketDetails &&
        this.formTicketLog!.situation &&
        this.formTicketLog!.description
      ) {
        //this.waitingSaveConfirmation = true; //por hora não vai ter a confirmação de salvamento, então chamar direto handleTicketLogSaved
        this.tcDataServiice.sendDetailEmitter.emit({
          observation: this.formTicketLog!.description,
          pub: this.pub,
        } as TicketDetail);
      } else {
        //this.openTicketSaveConfirmationModal();
      }

      this.handleTicketLogSaved();
    }
  }

  async updateTicketStatus() {
    this.saving = true;
    let response = await this.tcTicketService
      .patchMultiple([
        {
          id: this.entity!.id,
          ticket_status_id: this.entity.status?.id,
        },
      ])
      .catch(e => {
        this.toastService.showResponseError(e, 'Houve um erro ao salvar');
      });
    this.saving = false;

    if (response?.length) {
      this.toastService.show({
        color: 'success',
        message: 'Status do chamado atualizado com sucesso',
      });
      this.saved.emit(true);
      this.assembleTicket.emit(null);
    }
  }

  async updateTaskStatus(task: Task) {
    this.saving = true;
    let response = await this.tcTaskService
      .patchMultiple([
        {
          id: task.id,
          ticket_status_id: task.status?.id,
        },
      ])
      .catch(e => {
        this.toastService.showResponseError(e, 'Houve um erro ao salvar');
      });
    this.saving = false;

    if (response?.length) {
      this.toastService.show({
        color: 'success',
        message: 'Status da tarefa atualizado com sucesso',
      });
      this.saved.emit(true);
      //this.assembleTicket.emit(null);
    }
  }

  handleTicketLogSaved(response?) {
    let timeout = this.apontarDesapontarDireto ? 100 : 0;

    setTimeout(() => {
      this.saving = false;

      if (response) {
        this.entity = response;
      }

      if (this.formTicketLog?.end_date) {
        this.currentTicketLogService.stopTicketLog(this.formTicketLog!);
      } else {
        this.currentTicketLogService.startTicketLog(this.formTicketLog!);
      }

      this.close();
    }, timeout);
  }

  selectSingleTicketLogTask() {
    if (this.entity?.tasks?.length === 1) {
      this.taskId = this.entity?.tasks[0].id;
    }
  }

  loadShouldAddDescriptionToTicketDetails() {
    let shouldAddDescriptionToTicketDetails = localStorage.getItem(
      'shouldAddDescriptionToTicketDetails'
    );

    if (shouldAddDescriptionToTicketDetails) {
      this.shouldAddDescriptionToTicketDetails = shouldAddDescriptionToTicketDetails === 'true';
    }
  }

  async findCurrentTicketLog() {
    this.currentTicketLog = undefined;
    let findOptions = {
      page: 1,
      perPage: 1,
      filters: [
        new FilterField({
          name: 'equal[ticket_id]',
          value: this.entity!.id,
          operator: FilterOperator.has,
          label: '',
        }),
        new FilterField({
          name: 'equal[user_id]',
          value: this.user!.id,
          operator: FilterOperator.has,
          label: '',
        }),
        new FilterField({
          name: 'null[end_date]',
          value: 1,
          operator: FilterOperator.has,
          label: '',
        }),
      ],
    };

    if (this.inputTask) {
      findOptions.filters.push(
        new FilterField({
          name: 'equal[task_id]',
          value: this.inputTask?.id,
          operator: FilterOperator.has,
          label: '',
        })
      );
    }

    if (this.inputSystem) {
      findOptions.filters.push(
        new FilterField({
          name: 'equal[system_id]',
          value: this.inputSystem?.id,
          operator: FilterOperator.has,
          label: '',
        })
      );
    }

    this.searchingCurrentTicketLog = true;
    let response = await this.tcTicketLogService.findAll(findOptions).catch(e => {
      console.error(e);
      this.toastService.show({ color: 'error', message: 'Houve um erro ao carregar os dados' });
    });
    this.searchingCurrentTicketLog = false;

    if (response?.data?.length) {
      this.currentTicketLog = response!.data[0];
      let ticketLogsModalLastPub = localStorage.getItem('ticketLogsModalLastPub');

      if (ticketLogsModalLastPub) {
        this.pub = ticketLogsModalLastPub === 'true';
      }

      setTimeout(() => {
        //Por causa do binding dos @Inputs
        this.systemPercentagesComponent.setDefaultSystemsPercentage();
      }, 1);
    } else {
      this.systemPercentagesComponent.reset();
    }

    this.setFormTicketLog();

    if (this.apontarDesapontarDireto) {
      this.save();
    }
  }

  // closeModal() {
  //   if (this.ticketUpdateConfirmationEmitterSubscription) {
  //     this.ticketUpdateConfirmationEmitterSubscription.unsubscribe();
  //   }

  //   this.modal.hide();
  // }

  close() {
    this.visible = false;
    this.closed.emit(null);
  }

  get mainButtonLabel() {
    let label = '';

    if (this.currentTicketLog) {
      label += 'Finalizar';
    } else {
      label += 'Iniciar';
    }

    //label += ' apontamento';

    if (this.formTicketLog?.system?.description) {
      label += ' no sistema ' + this.formTicketLog?.system?.description;
    }

    return label;
  }

  get taskRadioDisabled(): boolean {
    return Boolean(this.currentTicketLog?.id || this.inputTask);
  }
}
